<template>
  <div v-show="show">
    <FormKit
      :help-position="helpPosition"
      :help="field.instructions"
      :label-position="labelPosition"
      :label="field.name"
      :name="name"
      :options="options"
      :placeholder="field.placeholder"
      :validation="validation"
      :value="field.defaultValue"
      type="select"
    />
  </div>
</template>

<script setup lang="ts">
import { fieldHelpPosition, fieldLabelPosition, fieldName, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: object
  parentField?: object
  field: object
}

const props = defineProps<Props>()

const helpPosition = fieldHelpPosition(props.settings, props.field)
const labelPosition = fieldLabelPosition(props.settings, props.field)
const name = fieldName(props.field, props.parentField)
const options = Object.fromEntries(props.field.entries.map(({ id, title }) => [id, title]))
const show = fieldVisible(props.field)
const validation = fieldValidationArray(props.field)
</script>
